module.exports = [
	{
		"label": "Assemblies of God",
		"value": "01"
	},
	{
		"label": "Baptist",
		"value": "02"
	},
	{
		"label": "Catholic",
		"value": "03"
	},
	{
		"label": "Church of Christ",
		"value": "04"
	},
	{
		"label": "Episcopalian/Anglican",
		"value": "05"
	},
	{
		"label": "Lutheran",
		"value": "06"
	},
	{
		"label": "Methodist/Wesleyan",
		"value": "07"
	},
	{
		"label": "Non-denominational",
		"value": "08"
	},
	{
		"label": "Pentecostal",
		"value": "09"
	},
	{
		"label": "Presbyterian",
		"value": "10"
	},
	{
		"label": "Other",
		"value": "11"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assess/question/denominations.json
// module id = 193
// module chunks = 0